import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save } from "lucide-react";
import api, { formatErr } from "../../lib/api";

export default function DevLimits() {
  const [s, setS] = useState({});
  useEffect(()=>{ api.get("/developer/settings").then(r=>setS(r.data)); }, []);
  const save = async () => {
    try {
      await api.put("/developer/settings", {
        product_limit: parseInt(s.product_limit),
        ai_per_user_daily: parseInt(s.ai_per_user_daily),
        ai_per_user_monthly: parseInt(s.ai_per_user_monthly),
        ai_global_daily: parseInt(s.ai_global_daily),
        ai_global_monthly: parseInt(s.ai_global_monthly),
        ai_max_variations_per_product: parseInt(s.ai_max_variations_per_product),
        ai_variations_per_request: parseInt(s.ai_variations_per_request),
        ai_cost_per_image_usd: parseFloat(s.ai_cost_per_image_usd),
        max_failed_attempts: parseInt(s.max_failed_attempts),
        lockout_window_hours: parseInt(s.lockout_window_hours),
        shipping_uae_aed: parseFloat(s.shipping_uae_aed),
        shipping_intl_aed: parseFloat(s.shipping_intl_aed),
        free_shipping_threshold_aed: parseFloat(s.free_shipping_threshold_aed),
      });
      toast.success("Limits saved");
    } catch (e) { toast.error(formatErr(e)); }
  };
  const Field = ({ k, l, type="number", step }) => (
    <div>
      <div className="text-[11px] uppercase tracking-luxe text-white/40 mb-1">{l}</div>
      <input data-testid={`lim-${k}`} type={type} step={step} className="input-box" value={s[k]??""} onChange={(e)=>setS({...s, [k]: e.target.value})}/>
    </div>
  );
  return (
    <div className="space-y-8">
      <div>
        <div className="overline mb-2">Configuration</div>
        <h1 className="font-display text-4xl text-white">Limits & Settings</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="card-luxe p-6">
          <div className="overline mb-4">Product Limit</div>
          <Field k="product_limit" l="Max Products"/>
        </div>
        <div className="card-luxe p-6">
          <div className="overline mb-4">Auth Lockout</div>
          <div className="grid grid-cols-2 gap-3">
            <Field k="max_failed_attempts" l="Max Failed Attempts"/>
            <Field k="lockout_window_hours" l="Window (Hours)"/>
          </div>
        </div>
        <div className="card-luxe p-6 md:col-span-2">
          <div className="overline mb-4">AI Image Generation Limits</div>
          <div className="grid md:grid-cols-2 gap-4">
            <Field k="ai_per_user_daily" l="Per User Daily"/>
            <Field k="ai_per_user_monthly" l="Per User Monthly"/>
            <Field k="ai_global_daily" l="Site-wide Daily"/>
            <Field k="ai_global_monthly" l="Site-wide Monthly"/>
            <Field k="ai_max_variations_per_product" l="Max Variations / Product"/>
            <Field k="ai_variations_per_request" l="Variations / Request (1-4)"/>
            <Field k="ai_cost_per_image_usd" l="Estimated Cost / Image (USD)" step="0.01"/>
          </div>
          <p className="text-xs text-white/40 mt-3">Set any value to 0 to make that limit unlimited (dangerous).</p>
        </div>
        <div className="card-luxe p-6 md:col-span-2">
          <div className="overline mb-4">Shipping Rates (AED)</div>
          <div className="grid md:grid-cols-3 gap-4">
            <Field k="shipping_uae_aed" l="Inside UAE" step="0.01"/>
            <Field k="shipping_intl_aed" l="International" step="0.01"/>
            <Field k="free_shipping_threshold_aed" l="Free Shipping Above" step="0.01"/>
          </div>
        </div>
      </div>
      <button data-testid="lim-save" onClick={save} className="btn-primary"><Save size={13}/> Save All</button>
    </div>
  );
}
